const doc = [({"en":({"deleteOnSend":"Automatically deleted when sent."})})];
module.exports = doc.length <= 1 ? doc[0] : doc;